// src/utils/langCookie.js
// Cookie ghi nhớ ngôn ngữ người dùng đã chọn (/en hoặc /vi).
// - Thuộc nhóm "functional" => chỉ ghi khi người dùng đã đồng ý cookie chức năng.
// - Chỉ dùng để quyết định redirect khi vào URL KHÔNG có prefix ngôn ngữ.
//   Nội dung của /en và /vi luôn quyết định bởi URL (tốt cho SEO).
import { hasConsent } from "./CookieConsent";

export const SUPPORTED_LANGS = ["en", "vi"];
export const DEFAULT_LANG = "en";

const COOKIE_NAME = "lang";
const ROOT_DOMAIN = "gopaperless.mobile-id.vn";
const MAX_AGE = 60 * 60 * 24 * 365; // 1 năm

// Chỉ gắn domain khi đang chạy trên domain thật (localhost sẽ bỏ qua để cookie không bị từ chối)
const domainAttr = () =>
  window.location.hostname.endsWith(ROOT_DOMAIN)
    ? `; domain=.${ROOT_DOMAIN}`
    : "";

const secureAttr = () =>
  window.location.protocol === "https:" ? "; Secure" : "";

// Lấy ngôn ngữ từ pathname: /vi, /vi/... => "vi"; /en, /en/... => "en"; còn lại => null
export function getLangFromPath(pathname) {
  const first = pathname.split("/")[1];
  return SUPPORTED_LANGS.includes(first) ? first : null;
}

export function getLangCookie() {
  const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  const value = m ? decodeURIComponent(m[1]) : null;
  return SUPPORTED_LANGS.includes(value) ? value : null;
}

export function setLangCookie(lang, { force = false } = {}) {
  if (!SUPPORTED_LANGS.includes(lang)) return;
  if (!force && !hasConsent("functional")) return; // chưa đồng ý cookie chức năng
  document.cookie =
    `${COOKIE_NAME}=${encodeURIComponent(lang)}; path=/; max-age=${MAX_AGE}; SameSite=Lax` +
    domainAttr() +
    secureAttr();
}

export function clearLangCookie() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${domainAttr()}`;
}

// Gọi sau khi người dùng bấm Accept / Reject / Save trong cookie banner
export function syncLangCookieWithConsent(functionalAllowed) {
  if (functionalAllowed) {
    const lang = getLangFromPath(window.location.pathname);
    if (lang) setLangCookie(lang, { force: true });
  } else {
    clearLangCookie();
  }
}

// Ngôn ngữ ưu tiên khi vào URL không có prefix: cookie -> trình duyệt -> mặc định
export function detectPreferredLang() {
  const fromCookie = getLangCookie();
  if (fromCookie) return fromCookie;

  const fromBrowser = (navigator.language || "").slice(0, 2).toLowerCase();
  if (SUPPORTED_LANGS.includes(fromBrowser)) return fromBrowser;

  return DEFAULT_LANG;
}
